export const VARIABLES_LOADING = 'VARIABLES_LOADING';
export const VARIABLES_LOADED = 'VARIABLES_LOADED';
export const VARIABLES_LOAD_ERROR = 'VARIABLES_LOAD_ERROR';
export const VARIABLE_CREATING = 'VARIABLE_CREATING';
export const VARIABLE_CREATED = 'VARIABLE_CREATED';
export const VARIABLE_CREATE_COMPLETE = 'VARIABLE_CREATE_COMPLETE';
export const VARIABLE_UPDATING = 'VARIABLE_UPDATING';
export const VARIABLE_UPDATED = 'VARIABLE_UPDATED';
export const VARIABLE_UPDATE_COMPLETE = 'VARIABLE_UPDATE_COMPLETE';
export const VARIABLE_DELETED = 'VARIABLE_DELETED';

export const ACTIONS_LOADING = 'ACTIONS_LOADING';
export const ACTIONS_LOADED = 'ACTIONS_LOADED';
export const ACTIONS_LOAD_ERROR = 'ACTIONS_LOAD_ERROR';
export const ACTION_CREATED = 'ACTION_CREATED';
export const ACTION_UPDATED = 'ACTION_UPDATED';
export const ACTION_DELETED = 'ACTION_DELETED';


// WEBPACK FOOTER //
// ./src/data/redux/botparams_details/actiontypes.js